import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import Cookies from "js-cookie";

/* eslint-disable */
export default {
  namespaced: true,
  state: {
    userp: Cookies.get("userp") ? JSON.parse(Cookies.get("userp")) : {},
    access_tokenp: Cookies.get("access_tokenp") || "",
    rolep: Cookies.get("rolep") ? JSON.parse(Cookies.get("rolep")) : []
  },
  actions,
  getters,
  mutations
};
